// extracted by mini-css-extract-plugin
export default {"infoBlock":"TopPageInfoBlock_infoBlock__V1-f1","infoBlockText":"TopPageInfoBlock_infoBlockText__c3ufQ","infoBlockSubText":"TopPageInfoBlock_infoBlockSubText__PD87c"};